'use client';

import React from 'react';
import { useLoadingStore } from '@/stores/loadingStore';
import LoadingOverlay from '@/components/ui/LoadingOverlay';

export default function GlobalLoadingOverlay() {
  // Use selectors to prevent unnecessary rerenders
  const isLoading = useLoadingStore((state) => state.isLoading);
  const loadingMessage = useLoadingStore((state) => state.loadingMessage);

  return <LoadingOverlay data-component-id="src/components/common/GlobalLoadingOverlay.tsx:12:9" data-component-path="src/components/common/GlobalLoadingOverlay.tsx" data-component-line="12" data-component-end-line="12" data-component-file="GlobalLoadingOverlay.tsx" data-component-name="LoadingOverlay" data-component-content="%7B%22elementName%22%3A%22LoadingOverlay%22%7D" isLoading={isLoading} message={loadingMessage || undefined} />;
}

